var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-header',{attrs:{"text":_vm.$t("ui.deviceCaption")}}),_c('v-card',{staticClass:"card-border-10",attrs:{"elevation":"0"}},[_c('d-table',{staticClass:"pt-10 px-10",attrs:{"table-data":_vm.items,"fields":_vm.fields,"loading":_vm.loading,"hide-search":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }